import { ComponentStruct } from "./Interfaces";

export const document_types = [
  { key: "6", label: "Instruction book" },
  { key: "7", label: "Parts list" },
  { key: "1", label: "Certificates" },
  { key: "2", label: "Electrical diagram" },
  { key: "3", label: "Flow diagram" },
  { key: "4", label: "Installation proposal" },
  { key: "5", label: "Dimension drawing" },
  { key: "8", label: "Software" },
  { key: "9", label: "Service instructions" },
];

export const document_descriptions = [
  { key: "1", type: "1", label: "CE certificate" },
  { key: "2", type: "1", label: "DoC certificate" },
  { key: "3", type: "1", label: "Test certificate" },
  { key: "4", type: "1", label: "Other" },
  { key: "5", type: "6", label: "Instruction book" },
  { key: "6", type: "6", label: "Supplement to instruction book" },
  { key: "7", type: "6", label: "Glossary" },
  { key: "8", type: "7", label: "Parts list" },
  { key: "9", type: "7", label: "Supplement to parts list" },
  { key: "10", type: "7", label: "Glossary" },
];

export const guid_mapping = [
  { guid: "00000000-0000-0000-0000-000000000000" },
  {
    guid: "00000000-0000-0000-0000-000000000001",
    type: { key: "1", label: "Certificates" },
    description: { key: "1", type: "1", label: "CE certificate" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000002",
    type: { key: "1", type: "1", label: "CE certificate" },
    description: { key: "2", type: "1", label: "DoC certificate" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000003",
    type: { key: "1", type: "1", label: "CE certificate" },
    description: { key: "3", type: "1", label: "Test certificate" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000004",
    type: { key: "1", type: "1", label: "CE certificate" },
    description: { key: "4", type: "1", label: "Other" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000005",
    type: { key: "2", label: "Electrical diagram" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000006",
    type: { key: "3", label: "Flow diagram" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000007",
    type: { key: "4", label: "Installation proposal" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000008",
    type: { key: "5", label: "Dimension drawing" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000009",
    type: { key: "6", label: "Instruction book" },
    description: { key: "5", type: "6", label: "Instruction book" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000010",
    type: { key: "6", label: "Instruction book" },
    description: {
      key: "6",
      type: "6",
      label: "Supplement to instruction book",
    },
  },
  {
    guid: "00000000-0000-0000-0000-000000000011",
    type: { key: "6", label: "Instruction book" },
    description: { key: "9", type: "6", label: "Glossary" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000012",
    type: { key: "7", label: "Parts list" },
    description: { key: "8", type: "7", label: "Part list" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000013",
    type: { key: "7", label: "Parts list" },
    description: { key: "9", type: "7", label: "Supplement to parts list" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000014",
    type: { key: "7", label: "Parts list" },
    description: { key: "10", type: "7", label: "Glossary" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000015",
    type: { key: "8", label: "Software" },
  },
  {
    guid: "00000000-0000-0000-0000-000000000016",
    type: { key: "9", label: "Service instructions" },
  },
];

export const languages: ComponentStruct[] = [
  { key: "ar", label: "Arabic" },
  { key: "bg", label: "Bulgarian" },
  { key: "zh", label: "Chinese" },
  { key: "hr", label: "Croatian" },
  { key: "cs", label: "Czech" },
  { key: "da", label: "Danish" },
  { key: "nl", label: "Dutch" },
  { key: "en", label: "English" },
  { key: "et", label: "Estonian" },
  { key: "fi", label: "Finnish" },
  { key: "fr", label: "French" },
  { key: "de", label: "German" },
  { key: "el", label: "Greek" },
  { key: "hu", label: "Hungarian" },
  { key: "it", label: "Italian" },
  { key: "ja", label: "Japanese" },
  { key: "ko", label: "Korean" },
  { key: "lv", label: "Latvian" },
  { key: "lt", label: "Lithuanian" },
  { key: "mk", label: "Macedonian" },
  { key: "mt", label: "Maltese" },
  { key: "no", label: "Norwegian" },
  { key: "pl", label: "Polish" },
  { key: "pt", label: "Portuguese" },
  { key: "pt-br", label: "Portuguese (Brazil)" },
  { key: "ro", label: "Romanian" },
  { key: "ru", label: "Russian" },
  { key: "sr", label: "Serbian" },
  { key: "sk", label: "Slovak" },
  { key: "sl", label: "Slovenian" },
  { key: "es", label: "Spanish" },
  { key: "sv", label: "Swedish" },
  { key: "th", label: "Thai" },
  { key: "tr", label: "Turkish" },
  { key: "uk", label: "Ukrainian" },
];

export const serialNumbers = [
  "PNA116220",
  "PNA116221",
  "PNA219246",
  "PNA219247",
  "PNA219262",
  "PNA219285",
  "PNA219293",
  "PNA219298",
  "APF207808",
  "APF207840",
  "APF207842",
  "APF207845",
  "APF207962",
  "APF208003",
  "API053598",
  "API053605",
  "API053604",
  "API053246",
  "API256897",
];

export const dateFormat = "DD/MM/YYYY";

export const MaxReasonLength = 150;
